const _ = require('lodash');

function TestLocalStorage($window) {
	this._window = $window;
}

TestLocalStorage.prototype.isSupported = function () {
	const TEST_KEY = 'TESTWRITE', storage = this._window.localStorage;
	if (_.isUndefined(storage)) return false;

	try {
		storage.setItem(TEST_KEY, '1'); // Safari Private browser this will throw an exception
		storage.removeItem(TEST_KEY);
		return true;
	} catch (error) {
		return false;
	}
};

module.exports = TestLocalStorage;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/localStorage/test-local-storage.js
 **/